import { CCOType } from "~/lib/schemas/db-enums";

/**
 * The CCO types shown on `/organizations`, in render order.
 *
 * Single source of truth for *which* CCO types are displayed and in *what*
 * order. Both the `/organizations` page (what it renders) and
 * `countGroupedCCOs` (what the `/coaching-intelligence` hub tile claims) must
 * iterate this list, so the count can never describe a different set than the
 * destination shows — they were previously two independent computations that
 * agreed only because `CCOType` happened to hold exactly these two members.
 *
 * Lives here rather than in `~/lib/ccos` because that module statically imports
 * `createServerFn` and `./server/s3`; importing it for a runtime value would
 * drag the server graph into the client bundle and jsdom unit tests.
 * `~/lib/ccos` re-exports this for callers already on the server side.
 *
 * Aliases: CCO order, organization type order, PAO CTO order.
 */
export const CCO_TYPE_ORDER = [CCOType.PAO, CCOType.CTO] as const;
